import { render, staticRenderFns } from "./articleManage.vue?vue&type=template&id=c5bfa9e6&scoped=true&"
import script from "./articleManage.vue?vue&type=script&lang=js&"
export * from "./articleManage.vue?vue&type=script&lang=js&"
import style0 from "./articleManage.vue?vue&type=style&index=0&id=c5bfa9e6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bfa9e6",
  null
  
)

export default component.exports